import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Radio,
  Typography,
} from '@mui/material';
import type { GrupoCajaChica } from '../../../services/tesoreriaService';

export interface FacturaPOSGrupoCajaDialogProps {
  open: boolean;
  loading?: boolean;
  grupos: GrupoCajaChica[];
  selectedId: number | null;
  onSelectId: (id: number) => void;
  onConfirm: () => void;
  onClose?: () => void;
}

const FacturaPOSGrupoCajaDialog: React.FC<FacturaPOSGrupoCajaDialogProps> = ({
  open,
  loading = false,
  grupos,
  selectedId,
  onSelectId,
  onConfirm,
  onClose,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    disableEscapeKeyDown={!onClose}
  >
    <DialogTitle>Grupo de caja</DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Tenés más de un grupo asignado. Elegí con cuál querés operar en esta sesión.
      </Typography>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
          <CircularProgress size={28} />
        </Box>
      ) : (
        <Grid container spacing={1.5}>
          {grupos.map((g) => (
            <Grid item xs={12} key={g.id}>
              <Card
                variant={selectedId === g.id ? 'elevation' : 'outlined'}
                sx={{ cursor: 'pointer' }}
                onClick={() => onSelectId(g.id)}
              >
                <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 1.25 }}>
                  <Radio
                    checked={selectedId === g.id}
                    onChange={() => onSelectId(g.id)}
                    value={g.id}
                  />
                  <Box>
                    <Typography fontWeight={600}>{g.nombre}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      Código: {g.codigo}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
          {grupos.length === 0 && (
            <Grid item xs={12}>
              <Typography variant="body2" color="text.secondary">
                No hay grupos de caja asignados a tu usuario.
              </Typography>
            </Grid>
          )}
        </Grid>
      )}
    </DialogContent>
    <DialogActions>
      {onClose ? <Button onClick={onClose}>Cancelar</Button> : null}
      <Button
        variant="contained"
        onClick={onConfirm}
        disabled={selectedId == null || loading}
      >
        Usar este grupo
      </Button>
    </DialogActions>
  </Dialog>
);

export default FacturaPOSGrupoCajaDialog;
